import React, { useEffect } from "react";
import { TawkChat } from "@/components";

const ExclusiveRelationshipsScreen: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="v2-body">
      <TawkChat />

      <div className="v2-hero">
        <img
          src={process.env.REACT_APP_URL_EXCLUSIVE_RELATIONSHIPS_BANNER}
          className="v2-hero-bg"
          alt="Mimo Cupido Casal"
          loading="eager"
        />
        <div className="v2-container">
          <div className="v2-hero-content">
            <h1>
              Relacionamentos Exclusivos <br />
              <span className="v2-gold-text">
                O Ápice da Privacidade e Sofisticação
              </span>
            </h1>
          </div>
        </div>
      </div>

      <section className="v2-section">
        <p>
          Projetado para quem não aceita nada menos do que a excelência. Seja
          você uma executiva brilhante, uma empresária de sucesso ou um
          profissional de alto nível, sabemos que seu estilo de vida exige
          parceiros que ofereçam tranquilidade, segurança e uma presença
          marcante.
        </p>
      </section>

      <section className="v2-section">
        <h2>O Padrão Ouro em Encontros Premium</h2>
        <p>
          Um relacionamento exclusivo é aquele onde não há joguinhos. As
          expectativas são claras e o respeito é o alicerce. Esta é a escolha
          perfeita para quem deseja: Atenção Direcionada: Envolver-se com
          parceiros focados, dedicados e que saibam tratar um relacionamento com
          a seriedade que ele merece. Equilíbrio Perfeito: O romance ideal para
          quem já tem a vida financeira e profissional resolvida e agora busca
          apenas desfrutar do que a vida tem de melhor acompanhado(a) de alguém
          especial. Experiências Sob Medida: Desde jantares confidenciais até
          viagens internacionais imprevistas.
        </p>
      </section>

      <section className="v2-section">
        <h2>Matchmaking Confidencial e Seguro</h2>
        <p>
          Sua vida pública e profissional não deve interferir no seu direito a
          um romance espetacular.
        </p>
      </section>

      <section className="v2-section">
        <h2>O Sigilo como Ferramenta de Conforto</h2>
        <p>
          Garantimos um ambiente onde a sua identidade e os seus dados são
          protegidos com protocolos de criptografia de alto nível.
          Relacionamentos exclusivos prosperam na discrição; por isso,
          oferecemos um santuário digital blindado para que você possa focar
          apenas em viver momentos inesquecíveis.
        </p>
      </section>
    </div>
  );
};

export default ExclusiveRelationshipsScreen;
